var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 38,
    viewBox: "0 0 25 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3467_9758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.7498C12.5 15.3333 15.2697 12.5635 18.6864 12.5635C22.103 12.5635 24.8727 15.3333 24.8727 18.7498C24.8727 22.1665 22.103 24.9362 18.6864 24.9362C15.2697 24.9362 12.5 22.1665 12.5 18.7498Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.126953 31.1229C0.126953 27.7063 2.89668 24.9365 6.31332 24.9365H12.4997V31.1229C12.4997 34.5396 9.72999 37.3093 6.31332 37.3093C2.89668 37.3093 0.126953 34.5396 0.126953 31.1229Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.191406V12.5641H18.6864C22.103 12.5641 24.8727 9.7944 24.8727 6.37777C24.8727 2.96114 22.103 0.191406 18.6864 0.191406H12.5Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.126953 6.37778C0.126953 9.79441 2.89668 12.5641 6.31332 12.5641H12.4997V0.191406H6.31332C2.89668 0.191406 0.126953 2.96114 0.126953 6.37778Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.126953 18.7498C0.126953 22.1665 2.89668 24.9362 6.31332 24.9362H12.4997V12.5635H6.31332C2.89668 12.5635 0.126953 15.3333 0.126953 18.7498Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3467_9758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 37.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.83068b1d113964373bbd7584ba3db1f5.svg";
export { ForwardRef as ReactComponent };